// extracted by mini-css-extract-plugin
module.exports = {"rosterBody":"roster_rosterBody__u_O1s","rosterYear":"roster_rosterYear__1gRuv"};